import { Logger, PreviewMode, UtilityService } from 'src/app/@shared';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ActivityLogDetailsDialogComponent } from 'src/app/@shared/components/activity-log-details-dialog/activity-log-details-dialog.component';
import { Offer, OfferDomain, OfferPromo, OfferPromoService, OfferService, PromoDomain, } from '../..';
import { Observable, Subscription, of, tap } from 'rxjs';
import { AuthorizationService } from 'src/app/@shared/services/authorization.service';
import { Status } from '../../models/offer-promo-status';
import * as dayjs from 'dayjs';

const log = new Logger('OfferAssetsComponent');

@Component({
  selector: 'app-offer-activitylog',
  templateUrl: './offer-activity-log.component.html',
  styleUrls: ['./offer-activity-log.component.scss'],
})
export class OfferActivityLogComponent<
  T extends Offer,
  TOfferPromo extends OfferPromo,
  TPromoDomain extends PromoDomain<OfferPromo>
> implements OnInit, OnDestroy {
  offer$: Observable<OfferDomain<T>> = of({} as OfferDomain<T>);

  displayedColumns: string[] = ['activity', 'user', 'time', 'details'];
  public activityDataSource: any = [];
  public offerId: string = '';
  subscription$ = new Subscription();
  readOnlyMode: boolean = false;
  offerDetails: any;
  PreviewMode = PreviewMode;

  constructor(
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private offerService: OfferService<Offer, OfferDomain<Offer>>,
    public utilityService: UtilityService,
    private authorizationService: AuthorizationService,
    private offerpromoService: OfferPromoService<TOfferPromo, TPromoDomain>
  ) { }

  ngOnInit(): void {
    this.offerId = this.route.snapshot.params['offerId'];
    this.offerpromoService.eventId = this.route.snapshot.params['eventId'];
    this.subscription$.add(
      this.offerService.getOfferLogs(this.offerId).subscribe((logs: any) => {
        this.activityDataSource = (logs as any[]).map((l) => ({
          Activity: l.ArchiveEdgeItem ? l.ArchiveEdgeItem.Activity : l.Activity,
          User: l.ArchiveEdgeItem ? l.ArchiveEdgeItem.UserName : l.UserName,
          Time: l.ArchiveEdgeItem ? l.ArchiveEdgeItem.ModifiedDate : l.ModifiedDate,
          Details: l.ArchiveEdgeItem ? l.ArchiveEdgeItem.OldNewPropertyValue : l.OldNewPropertyValue
        }));
      })
    );
  }

  viewDetails(i: number) {
    this.dialog.open(ActivityLogDetailsDialogComponent, {
      data: {
        details: this.activityDataSource[i]?.Details,
      },
      disableClose: true,
    });
  }

  canEdit(): boolean {
    const hasAccess =
      this.authorizationService.checkAccess('edit||offermang') &&
      this.readOnlyMode != true;

    return hasAccess;
  }

  processCurrentOffer() {
    this.offerService.processOfferLogs(this.offerId).subscribe((logs: any) => {
      this.activityDataSource = (logs as any[]).map((l) => ({
        Activity: l.ArchiveEdgeItem ? l.ArchiveEdgeItem.Activity : l.Activity,
        User: l.ArchiveEdgeItem ? l.ArchiveEdgeItem.UserName : l.UserName,
        Time: l.ArchiveEdgeItem ? l.ArchiveEdgeItem.ModifiedDate : l.ModifiedDate,
        Details: l.ArchiveEdgeItem ? l.ArchiveEdgeItem.OldNewPropertyValue : l.OldNewPropertyValue
      }));
    })
  }
  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }
}
